
import { common as frCommon } from './fr/common';
import { common as enCommon } from './en/common';

const messages = {
  fr: {
    common: frCommon
  },
  en: {
    common: enCommon
  }
};

export default messages;
